import { Component, Input, OnInit } from "@angular/core";
import { DialogService } from "primeng/dynamicdialog";
import { DistrictAdministrationService } from "../../../services/districtadministration.service";
import { DistrictSchoolAddFacilityComponent } from "./district-school-add-facility/district-school-add-facility.component";

@Component({
	selector: "caass-facility-assign",
	templateUrl: "./facility-assign.component.html",
	styleUrls: ["./facility-assign.component.css"],
})
export class FacilityAssignComponent implements OnInit {
	constructor(private dialogService: DialogService, private districtadministrationService: DistrictAdministrationService) {}

	ngOnInit(): void {
		if (this.SchoolIDFromMain != undefined) {
			this.loadFacilities();
		}
	}

	ngOnChanges() {
		if (this.SchoolIDFromMain != undefined) {
			this.loadFacilities();
		}
	}

	///////////////////////////////////////////////////////
	// Data
	///////////////////////////////////////////////////////
	@Input() SchoolIDFromMain: any;

	lstFacility: any = [];
	SelectedFacilities: any = [];
	lstActive: any = [];

	pagerows: any = 10;
	pagefirst: any = 0;

	cols = [
		{ field: "FacilityName", header: "Facility Name" },
		{ field: "FacilityCD", header: "Facility Code" },
		{ field: "Active", header: "Active" },
	];

	errorMessage: any = "";

	///////////////////////////////////////////////////////

	///////////////////////////////////////////////////////
	// Load Data
	///////////////////////////////////////////////////////
	loadFacilities() {
		var result = this.districtadministrationService.LoadSchoolFacilities(this.SchoolIDFromMain);
		result.subscribe((response) => {
			this.lstFacility = response;

			for (var i = 0; i < this.lstFacility.length; i++) {
				this.lstFacility[i].Active = this.lstFacility[i].Active == 1 ? "Active" : "Inactive";
			}

			this.lstActive = Array.from(new Set(this.lstFacility.map((item: any) => item.Active))).sort();
		});
	}

	///////////////////////////////////////////////////////

	///////////////////////////////////////////////////////
	// Buttons
	///////////////////////////////////////////////////////
	onRemove() {
		this.errorMessage = "";

		if (this.SelectedFacilities.length == 0) {
			this.errorMessage = "Select Facilities to remove";
		}

		this.lstFacility = this.lstFacility.filter((facility) => this.SelectedFacilities.indexOf(facility) == -1);

		this.SelectedFacilities = [];
	}
	onAdd() {
		this.errorMessage = "";

		var ref = this.dialogService.open(DistrictSchoolAddFacilityComponent, {
			header: "Add Facilities",
			width: "fit-content",
			data: {
				SelectedFacilities: this.lstFacility,
			},
		});
		ref.onClose.subscribe((response) => {
			if (response != 0) {
				this.lstFacility = response;

				for (var i = 0; i < this.lstFacility.length; i++) {
					this.lstFacility[i].Active = this.lstFacility[i].Active == 1 ? "Active" : "Inactive";
				}

				this.lstActive = Array.from(new Set(this.lstFacility.map((item: any) => item.Active))).sort();
			}
		});
	}
	///////////////////////////////////////////////////////

	///////////////////////////////////////////////////////
	// Events
	///////////////////////////////////////////////////////
	onHandleFilter(val) {}
	onHandleSort(val) {}
	onRowSelect(val) {}
	onRowUnselect(val) {}
	///////////////////////////////////////////////////////
}
